import { post, del } from '../util/secure_fetch.js';

export async function addFavorite(variationIds) {
  return post(`/fonts/variation_favorites?font_variation_ids=${variationIds.join(',')}`);
}

export async function removeFavorite(variationIds) {
  return del(`/fonts/variation_favorites?font_variation_ids=${variationIds.join(',')}`);
}
